import axios from 'axios'
import globals from '../globals'

export default function getCoordTransform(srsIn, srsOut, x, y) {
  let url = `${globals.RL_TRANSFORM_POINT_SERVICE}${srsIn}/${srsOut}/${x},${y}`
  return axios.get(url, {})
}



// WEBPACK FOOTER //
// ./D:/node-prj/geoviewer2/src/services/getCoordTransform.js